<ion-ripple-effect *ngIf="ripple"></ion-ripple-effect>

<v2-row justifyContent="space-between" alignItems="center">
  <v2-row alignItems="center">
    <div class="leading" #leadingEl>
      <ng-content select="[leading]"></ng-content>
    </div>

    <div class="title" #titleEl>
      <ng-content select="[title]"></ng-content>
    </div>
  </v2-row>

  <v2-row alignItems="center" class="trailing-cont">
    <div class="pre-trailing">
      <ng-content select="[pre-trailing]"></ng-content>
    </div>

    <div class="trailing">
      <ng-content select="[trailing]"></ng-content>
    </div>
  </v2-row>
</v2-row>

<v2-row>
  <div
    class="subtitle"
    [style.marginLeft]="subtitleMarginLeft$ | async"
    [style.marginTop]="subtitleMarginTop$ | async"
  >
    <ng-content select="[subtitle]"></ng-content>
  </div>
</v2-row>
